import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

import { TouchMouseInput } from 'hammerjs';

@Injectable()
export class PopularBetsHammerGestureConfigProvider extends HammerGestureConfig {
    private swipeVelocity = 0.01;

    override overrides = {
        swipe: {
            direction: Hammer.DIRECTION_HORIZONTAL,
            velocity: this.swipeVelocity,
        },
    };

    override options = {
        inputClass: TouchMouseInput,
    };
}
